import React, { useContext, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import PropTypes from "prop-types";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";

export default function SitesDetailsTile({
  title,
  selectedOperator,
  onchangeOperator,
  deSelectable = false,
  counts = [],
  showCounts = false,
  allOperators = [],
  permitedOperatorData = [],
  ...props
}) {
  const getCountByOprt = (op) => {
    const opData = counts.find(x => x.operator === op);
    return opData?.count || 0;
  }

  return (
    <Grid
      container
      xs={12}
      sm={12}
      md={12}
      style={{
        justifyContent: "space-between",
        margin: "5px 5px 0px",
        padding: "10px",
        font: "normal normal 500 13px/18px Open Sans",
        background: "#FFFFFF 0% 0% no-repeat padding-box",
        border: "1px solid #007842",
        borderRadius: "5px",
        opacity: "1",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        style={{
          marginBottom: "5px",
          textAlign: "left",
          font: "normal normal 550 13px/18px Open Sans",
          letterSpacing: "0px",
          color: "black",
          opacity: "1",
        }}
      >
        {title}
      </Grid>
      <Grid container item style={{ justifyContent: "flex-start" }}>
        {permitedOperatorData.length && permitedOperatorData.map((x) => (
          <Grid
            item
            md={2.5}
            style={{
              margin: "1px 5px 5px 5px",
              border: `${selectedOperator == x.operator ? "2px" : "1px"
                } solid #007842`,
              borderRadius: "4px",
              cursor: "pointer",
              height: showCounts ? "60px" : "auto",
              width: "50px",
              background: "#FFFFFF 0% 0% no-repeat padding-box",
              boxShadow: "0px 2px 4px #00000026",
            }}
            onClick={() => onchangeOperator(deSelectable && selectedOperator === x.operator ? null : x.operator)}
          >
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "3px",
              height: "36px",
              width: "100%"
            }}>
              {x.icon && !x.isAnonymized ?
                <img
                  src={x.icon}
                  alt={x.name}
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                  className="center"
                  vertical-align="middle"
                /> : <h4 style={{ color: "#036116", fontSize: "10px", textAlign: "center", lineHeight: "8px" }}>{x.name}</h4>}
            </div>
            {showCounts
              ? <>
                <div style={{ height: "1px", width: "100%", backgroundColor: "#007842", marginTop: "3px" }} />
                <p style={{ color: "#036116", fontSize: "10px", textAlign: "center", margin: "0px" }}>{getCountByOprt(x.operator)}</p>
              </>
              : <></>}
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}

SitesDetailsTile.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
};

SitesDetailsTile.defaultProps = {
  title: undefined,
  icon: undefined,
};
